"use client"
import React from 'react'
import "./App.css"
export default function Navbar() {
  return (
    <div>
          <div id="Navbar" >
        <div id="Heading-Space">
            <p id="Heading">Yash.</p>
            <div id="image-Space">
                <a href="https://github.com/yashk40"><img id="image-nav" src="Github.svg" alt="Github"/></a>
                <a href="https://www.linkedin.com/in/yashkumawt"><img id="image-nav" src="linkdin.svg" alt="LinkedIn"/></a>
                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=Ykumawat006@gmail.com" target="_blank" rel="noopener noreferrer"><img id="image-nav" src="Mail.svg" alt="Email"/></a>     
                <a href="https://drive.google.com/file/d/1btXJWhNnHEEaJfQnwCxk3O_FTR8a7EJA/view"><img id="image-nav" src="Page.svg" alt="Resume"/></a>    
            </div>
            <div id='Navbar-Links-2'>
                <a href='https://github.com/yashk40' id='github'>Github</a>
                <a href='https://www.linkedin.com/in/yashkumawt' id='linkedin'>Linkedin</a>
                <a href='https://drive.google.com/file/d/1btXJWhNnHEEaJfQnwCxk3O_FTR8a7EJA/view' id='Resume'>Resume</a>
            </div>
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=Ykumawat006@gmail.com" target="_blank" rel="noopener noreferrer" id="Gmail" style={{color:"#F9F0E1"}}>Ykumawat006@gmail.com</a>
          
        </div>
        
    </div>
    </div>
  )
}
